import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./tailwind.css";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env["VITE_REACT_APP_SENTRY_DSN"],
  sendDefaultPii: false,
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
